<template>
  <div>
    <b-card>
      <b-row>
        <b-col 
          cols="6"
          class="px-2 my-auto"
        >
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ roleData.name }}
              </h4>
              <div class="card-text">
                {{ roleData.description }}
              </div>
            </div>
            <div class="d-flex flex-wrap">
              <b-button
                :to="{ name: 'roles-edit', params: { id: roleData.id } }"
                variant="primary"
              >
                Edit Role
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <table class="mt-2 mt-xl-0 w-100">
            <!-- Created At -->
            <tr>
              <th class="pb-50">
                <feather-icon
                  icon="ClockIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">Created At</span>
              </th>
              <td>
                <!-- {{ $formatDatetime(roleData.created_at) }} -->
                {{ roleData.created_at }}
              </td>
            </tr>

            <!-- Created by -->
            <tr>
              <th class="pb-50">
                <feather-icon
                  icon="UserIcon"
                  class="mr-75"
                />
                <span class="font-weight-bold">Created By</span>
              </th>
              <td>
                {{ roleData.created_by }}
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-card>

    <b-card>
      <permissions-card
        v-if="roleData.permissions"
        :disabled="true"
        :user-permissions="roleData.permissions"
      />
    </b-card>

    <!-- <b-card>
      <h1> table of users with this role </h1>
    </b-card> -->
  </div>
</template>

<script>
import PermissionsCard from '@/views/user-management-system/components/PermissionsCard.vue'

export default {
  components: {
    PermissionsCard,
  },
  data() {
    return {
      roleData: {},
      showPermissionsCard: false,
    }
  },
  watch: {
    'roleData.permissions': function (newVal, oldVald) {
      this.showPermissionsCard = true
    }
  },
  created() {
    // this.get_role()
    // this.get_users_with_this_role()

    this.populateMockData()
  },
  methods: {
    populateMockData() {
      this.roleData = {
        id: '2b0578a5-dc61-4bfa-bff4-343aa87ef8d3',
        name: 'Administrator',
        description: 'Roles with all read, write, update and delete priviledge',
        // created_at: '2023-03-05 10:34:32',
        created_at: '5th Mar 2023 10:34:32',
        permissions: [
          {
              "title": "Analytics",
              "section": "Analytics",
              "unique_name": "Analytics",
              "read": true,
              "write": true,
              "update": true,
              "delete": true
          },
          {
              "title": "ATS System",
              "section": "ATS System",
              "unique_name": "ATS System",
              "read": true,
              "write": true,
              "update": true,
              "delete": true
          },
          {
              "title": "Audit Log",
              "section": "Audit Log",
              "unique_name": "Audit Log",
              "read": true,
              "write": true,
              "update": true,
              "delete": true
          },
          {
              "title": "Data Manager",
              "section": "Data Manager",
              "unique_name": "Data Manager",
              "read": true,
              "write": true,
              "update": true,
              "delete": true
          },
          {
              "title": "User Manager",
              "section": "User Manager",
              "unique_name": "User Manager",
              "read": true,
              "write": true,
              "update": true,
              "delete": true
          }
        ],
      }

      const userInfo = this.$store.state.auth.ActiveUser
      if (userInfo.user_group.includes('admin')) {
        this.roleData.created_by = 'talent@designsingapore.org'
      } else if (userInfo.user_group.includes('employer')) {
        this.roleData.created_by = 'Administrator@employer.com'
      }


    },
    get_role() {
      const { id } = this.$route.params
 
      this.$http
        .get(`/api/roles/${id}`)
        .then(response => {
          this.roleData = response.data

          const { permissions } = this.roleData
          this.$set(this.roleData, 'permissions', {})
          this.$set(this.roleData, 'permissions', permissions)
        })
        .catch(error => {
          this.$handleErrorResponse(error)
          const { response } = error

          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Operation Failed',
                icon: 'CheckCircleIcon',
                text: response.data.message,
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )

          this.isLoading = false
        })
    },
    get_users_with_this_role() {
      const { id } = this.$route.params
 
      this.$http
        // .get(`/api/users?filter_by_role=${id}`)
        .get(`/api/roles/${id}/users`)
        .then(response => {
          this.usersData = response.data.output
        })
        .catch(error => {
          const { response } = error

          this.$toast(
            {
              component: this.$toastContent,
              props: {
                title: 'Operation Failed',
                icon: 'CheckCircleIcon',
                text: response.data.message,
                variant: 'danger',
              },
            },
            { timeout: this.$longestTimeout },
          )

          this.isLoading = false
        })
    },
  },
}
</script>

<style>

</style>
